var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 47,
    viewBox: "0 0 46 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_420_20681)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_420_20681)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 44C35.1503 44 45 34.1503 45 22C45 9.84974 35.1503 0 23 0C10.8497 0 1 9.84974 1 22C1 34.1503 10.8497 44 23 44Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0469 21.9999H45.0034C45.0034 20.0142 44.7387 18.0906 44.2455 16.2607H22.0469V21.9999Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0469 10.5214H41.7743C40.4276 8.3238 38.7057 6.38135 36.698 4.78223H22.0469V10.5214Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9993 43.9994C28.177 43.9994 32.9359 42.2098 36.694 39.2168H9.30469C13.0627 42.2098 17.8217 43.9994 22.9993 43.9994Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.22895 33.4774H41.7709C42.8521 31.7132 43.6906 29.7848 44.242 27.7383H1.75781C2.30927 29.7848 3.14777 31.7132 4.22895 33.4774Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1908 3.43561H13.1956L11.3308 4.79041L12.0431 6.98259L10.1784 5.62779L8.31362 6.98259L8.92894 5.08879C7.28702 6.45648 5.84791 8.05888 4.66197 9.84431H5.30435L4.1173 10.7067C3.93236 11.0152 3.75498 11.3286 3.585 11.6467L4.15184 13.3913L3.0943 12.6229C2.83141 13.1799 2.59096 13.7494 2.37483 14.3308L2.99934 16.253H5.30435L3.43951 17.6078L4.15184 19.8L2.28709 18.4452L1.17007 19.2568C1.05827 20.1555 1 21.0709 1 22H23C23 9.84981 23 8.41741 23 0C18.654 0 14.6026 1.2607 11.1908 3.43561ZM12.0431 19.8L10.1784 18.4452L8.31362 19.8L9.02596 17.6078L7.16112 16.253H9.46613L10.1784 14.0608L10.8906 16.253H13.1956L11.3308 17.6078L12.0431 19.8ZM11.3308 11.1991L12.0431 13.3913L10.1784 12.0365L8.31362 13.3913L9.02596 11.1991L7.16112 9.84431H9.46613L10.1784 7.65213L10.8906 9.84431H13.1956L11.3308 11.1991ZM19.9344 19.8L18.0697 18.4452L16.2049 19.8L16.9173 17.6078L15.0524 16.253H17.3574L18.0697 14.0608L18.7819 16.253H21.0869L19.2221 17.6078L19.9344 19.8ZM19.2221 11.1991L19.9344 13.3913L18.0697 12.0365L16.2049 13.3913L16.9173 11.1991L15.0524 9.84431H17.3574L18.0697 7.65213L18.7819 9.84431H21.0869L19.2221 11.1991ZM19.2221 4.79041L19.9344 6.98259L18.0697 5.62779L16.2049 6.98259L16.9173 4.79041L15.0524 3.43561H17.3574L18.0697 1.24343L18.7819 3.43561H21.0869L19.2221 4.79041Z",
    fill: "#0052B4"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_420_20681",
    x: 0,
    y: 0,
    width: 46,
    height: 47,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0901961 0 0 0 0 0.137255 0 0 0 0 0.223529 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_420_20681"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_420_20681",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_420_20681"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    width: 44,
    height: 44,
    rx: 22,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsCircle);
export default __webpack_public_path__ + "static/media/us-circle.ae8a6162f17cf560a35a0f03edb0958e.svg";
export { ForwardRef as ReactComponent };